import React, { Component } from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  ViberShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  ViberIcon,
  EmailIcon

} from 'react-share'

import './styles.sass'

class Share extends Component {
  render() {
    const {
      title, url, excerpt,
      showFB = true, showTwitter = true,
      showViber = true, showEmail = true
    } = this.props

    const iconSize = 40

    return (
      <div className='social-links'>
        { showFB &&
          <FacebookShareButton url={url} quote={excerpt} className="share-button"> 
            <FacebookIcon round size={iconSize} />
          </FacebookShareButton>
        }
        { showTwitter &&
          <TwitterShareButton url={url} title={title} className="share-button">
            <TwitterIcon round size={iconSize} />
          </TwitterShareButton>
        }
        { showViber &&
          <ViberShareButton url={url} title={title} className="share-button">
            <ViberIcon round size={iconSize} />
          </ViberShareButton>
        }
        { showEmail &&
          <EmailShareButton url={url} subject={title} body={excerpt} className="share-button">
            <EmailIcon round size={iconSize} />
          </EmailShareButton>
        }
      </div>
    )
  }
}

export default Share
